<template>
  <div>
    <b-table
      striped
      hover
      no-provider-filtering
      no-provider-paging
      no-provider-sorting
      no-local-sorting
      :items="workloads"
      :fields="fields"
      @sort-changed="changeSort"
      responsive
      show-empty
    >
      <template v-slot:cell(discrepancy)="data">
        <font-awesome-icon
          icon="exclamation-circle"
          class="text-danger"
          v-b-tooltip.hover
          title="Number of planned courses is different than number of scheduled courses."
          v-if="!actualCoursesMatchPlanned(data.item)"
        ></font-awesome-icon>
      </template>
      <template v-slot:cell(differsFromPrevious)="data">
        <font-awesome-icon
          icon="exclamation-triangle"
          class="text-danger"
          v-b-tooltip.hover
          title="This workload differs from previously approved workloads."
          v-if="data.item.differsFromPrevious"
        ></font-awesome-icon>
      </template>
      <template v-slot:cell(name)="data">
        {{ data.item.asurite.lastName }}, {{ data.item.asurite.firstName }}
      </template>
      <template v-slot:cell(jobcodeDescr)="data">
        <div>
          <div v-for="(job, index) in data.item.employeeJobs" :key="index">
            {{ job.job.description }} - {{ job.department.description }}
            <span v-if="job.jobIndicator == 'P'">(Primary)</span>
          </div>
        </div>
      </template>
      <template
        v-for="workloadTypeDefinition in workloadTypeDefinitions"
        v-slot:[dynamicCellName(workloadTypeDefinition.name)]="data"
      >
        {{
          getWorkloadType(
            data.item.workloadTypes,
            workloadTypeDefinition.workloadTypeDefinitionId
          )
            ? getWorkloadType(
                data.item.workloadTypes,
                workloadTypeDefinition.workloadTypeDefinitionId
              ).value
            : 0 | percentage(0)
        }}
      </template>
      <template v-slot:cell(status)="data">
        {{ getCurrentStatusDefinitionName(data.item.workloadStatuses) }}
      </template>
      <template v-slot:cell(effectiveDate)="data">
        {{ data.item.effectiveDate | formatDateTime }}
      </template>
      <template v-slot:cell(details)="data">
        <router-link
          :to="{
            name: 'workload',
            params: { workloadId: data.item.workloadId },
          }"
          >Details</router-link
        >
        <span v-if="isWorkloadsManager">
          |
          <router-link
            :to="{
              name: 'workloadAddBehalf',
              params: { asurite: data.item.asuriteId },
              query: { timePeriod: data.item.timePeriodId },
            }"
            >Submit on Behalf</router-link
          >
        </span>
      </template>
    </b-table>

    <b-pagination
      :total-rows="meta.totalRows"
      v-model="meta.currentPage"
      :per-page="meta.perPage"
      align="right"
      @change="changePage"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import roleChecks from "../../misc/role-checks";

export default {
  mixins: [roleChecks],
  data() {
    return {};
  },

  props: {
    workloads: {
      type: Array,
      required: true,
      default() {
        return [];
      },
    },
    workloadTypeDefinitions: {
      type: Array,
      required: true,
    },

    showStatusField: {
      type: Boolean,
      required: false,
      default: false,
    },
    showDateField: {
      type: Boolean,
      required: false,
      default: false,
    },
    showDiscrepancyCol: {
      type: Boolean,
      required: false,
      default: false,
    },
    showDiffersCol: {
      type: Boolean,
      required: false,
      default: false,
    },
    meta: {
      type: Object,
      require: true,
    },
  },

  computed: {
    fields: function() {
      var tableFields = [];

      if (this.showDiscrepancyCol) {
        tableFields.push({ key: "discrepancy", label: "" });
      }

      if (this.showDiffersCol) {
        tableFields.push({ key: "differsFromPrevious", label: "" });
      }

      tableFields.push({ key: "name", sortable: true });
      tableFields.push({ key: "asuriteId", sortable: true });
      tableFields.push({ key: "jobcodeDescr", sortable: true });

      if (this.showStatusField) {
        tableFields.push({ key: "status", sortable: true });
      }

      if (this.showDateField) {
        tableFields.push({ key: "effectiveDate", sortable: true });
      }

      _.forEach(this.workloadTypeDefinitions, function(workloadTypeDefinition) {
        var newField = {
          key: workloadTypeDefinition.name,
          label: workloadTypeDefinition.name + " (%)",
          sortable: true,
        };
        tableFields.push(newField);
      });

      tableFields.push({ key: "details", label: "" });

      return tableFields;
    },
  },

  methods: {
    changeSort(context) {
      this.$emit("sort", {
        sortBy: context.sortBy,
        sortDesc: context.sortDesc,
      });
    },

    changePage(page) {
      this.$emit("page", page);
    },

    dynamicCellName(name) {
      return "cell(" + name + ")";
    },

    getPrimaryEmployeeJob(employeeJobs) {
      if (!employeeJobs.length) {
        return null;
      }
      var primary = _.find(employeeJobs, function(employeeJob) {
        return employeeJob.jobIndicator === "P";
      });
      if (primary) {
        return primary;
      }
      return employeeJobs[0];
    },

    getCurrentStatusDefinitionName(workloadStatuses) {
      if (workloadStatuses && workloadStatuses.length) {
        var currentStatus = _.maxBy(workloadStatuses, function(workloadStatus) {
          return new Date(workloadStatus.createdDate);
        });
        return (
          currentStatus.workloadStatusDefinition.name +
          " by " +
          currentStatus.createdBy
        );
      }
      return "";
    },

    getWorkloadType(workloadTypes, workloadTypeDefinitionId) {
      return _.find(workloadTypes, function(workloadType) {
        return (
          workloadType.workloadTypeDefinitionId === workloadTypeDefinitionId
        );
      });
    },

    // returns true if actual courses match planned courses
    actualCoursesMatchPlanned(workload) {
      if (workload.courseCount == workload.classCount) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style scoped>
</style>
